import {useEffect, useState} from "react";
import zoomImg from "../../../../assets/icons/imgBtn.svg";
import image1 from "../../../../assets/images/Blog34/image1 fed for Sep.png";
import image10 from "../../../../assets/images/Blog34/image10 gold lt fib help.png";
import image11 from "../../../../assets/images/Blog34/image11 gold st fib levels.png";
import image12 from "../../../../assets/images/Blog34/image12 gold inflation adjusted.png";
import image13 from "../../../../assets/images/Blog34/image13 SOX highs.png";
import image14 from "../../../../assets/images/Blog34/image14 nas100 fake breakout or not_.png";
import image16 from "../../../../assets/images/Blog34/image16 US retail sales grow but slow.png";
import image2 from "../../../../assets/images/Blog34/image2 fed by dec25.png";
import image3 from "../../../../assets/images/Blog34/image3 market view v dotplot 2026.png";
import image5 from "../../../../assets/images/Blog34/image5 market skew in expiry week.png";
import image6 from "../../../../assets/images/Blog34/image6 cny deflation.png";
import image7 from "../../../../assets/images/Blog34/image7 china slowing fast.png";
import image8 from "../../../../assets/images/Blog34/image8 china investment slowing too.png";
import image9 from "../../../../assets/images/Blog34/image9 IMF global growth needs china .png";
import BlogImagePopper from "./BlogImageLarge";

const Blog34 = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const handleRedirect = (url) => {
    window.open(url, "_blank");
  };
  const handleLargeImg = (img) => {
    setSelectedImage(img);
  };
  return (
    <div className="MainNewBlog">
      <div className="blogHeader">
        <h2 className="headerBoldText mainHeader">Weekly Market Outlook – September 15th, 2025</h2>
      </div>
      <div className="blogContentnew">
        <p className="highlightedText">Fed’s First Cut, China’s Deflation Shock, and Gold at Record Highs</p>
        <p>
          Markets head into one of the heaviest central bank weeks of 2025 with the Fed poised for its first rate cut in nine months, China sliding deeper into deflation, and gold streaking toward new
          records. Traders are bracing for dot-plot surprises, cross-asset whipsaws, and a liquidity surge that could either extend the rally or trap late buyers.
        </p>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Market Overview – A Cut is Coming, but at What Cost?</p>
              <p>
                Last week’s softer U.S. labour data and weak PPI opened the door for the Fed to cut rates at Wednesday’s FOMC, taking the target to 4.0–4.25%. Markets are already pricing in 75 bps of
                cuts by year-end, with a 97% probability according to CME data.
              </p>
              <p>
                But the bigger question is the path of cuts into 2026. Traders are watching the dot plot to see whether the Fed endorses the market’s -150 bps by 2026 versus the current -100 bps.
                Meanwhile, the 10-year yield’s “risk-on” line at 4% and “risk-off” line at 4.5% offers a simple roadmap for positioning.
              </p>
              <p>Personnel risk adds drama: Lisa Cook’s legal case and Stephen Miran’s possible dissent (in favour of 50 bp) could inject intraday volatility.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image1}
                    alt="Fed for Sep"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image1)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>

                <div className="relatedImg">
                  <img
                    src={image2}
                    alt="Fed by Dec2"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image2)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Macro & Policy Watch – Global Easing Blitz Meets China’s Drag</p>
              <p>
                Roughly 40% of the world economy faces rate decisions this week. Canada (-25 bp expected), Norway (-25 bp expected), and BOE (unchanged) join the Fed, while Brazil and the BOJ also
                take the stage. Easy policy is the week’s central theme, but any outsized Fed cut would roil Treasuries and global risk assets.
              </p>
              <p>
                China is the other macro pivot. Retail sales and investment missed forecasts, unemployment ticked higher, and deflation deepened—casting doubt on Q3/Q4 global growth assumptions.
                Stimulus is still limited, leaving markets to guess when the fiscal hammer drops.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image6}
                    alt="CNY deflation"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image6)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="China slowing fast"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image8}
                    alt="China investment slowing too"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image8)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image9}
                    alt="IMF global growth needs China"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image9)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <p>
                The UK, meanwhile, posted flat GDP with industrial production reversing sharply and manufacturing output sliding. Services and construction managed small gains, but not enough to
                justify another BOE cut yet.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper flexDiv">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Technical & Sentiment Breakdown – Gold’s Fib Power and NAS100’s Breakout</p>
              <p className="highlightedText">Gold – From Textbook Fib to Textbook Breakout</p>
              <p>
                Gold has gained nearly 40% YTD and now trades above $3,600—its strongest week in months and beyond its inflation-adjusted 1980 high. Weakening real yields, dovish monetary policy, and
                a soft dollar fuel this surge.
              </p>
              <p>
                Long-term Fibonacci extensions nailed the $3,500 top of wave 3 (3.618 extension). The ABCDE triangle retraced to the 0.146 level at $3,253 before breaking higher. Using i = v
                projections, a move toward ~$3,720 is in play before the next pause. Short term, expect 3,500–3,650 consolidation before a new ATH above 3,700.
              </p>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="Gold LT Fib"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image11}
                    alt="Gold ST Fi"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image11)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image12}
                    alt="Gold inflation adjusted"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image12)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Equities – Breakout or Fakeout?</p>
              <p>
                Dow, NAS100, and SPX all hit new highs. Tesla surged 12.85% on the week while semiconductors reached record peaks. Yet, with FOMC week and heavy expiries ahead, NAS100 could be staging
                an “expanding flat” fakeout before resuming higher.
              </p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image13}
                    alt="SOX highs"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image13)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="NAS100 fake breakout or not?"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <p>
              In the UK, FTSE miners Rio Tinto, Glencore, and Anglo American drive index strength as M&A speculation heats up, while gold miners like Hochschild and Fresnillo extend the sector’s
              standout YTD performance.
            </p>

            <div className="contentDiv listOfRecap">
              <p className="highlightedText">Positioning – Skew Shifts into Fed</p>
              <p>Call skew shows upside appetite into the Fed, but Friday expiries revealed downside skew—signalling hedges that could unwind or neutralise post-FOMC.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="Market skew in expiry week"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />

        <div className="subHeader">
          <div className="contentDivWrapper flexDiv ">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Last Week’s Recap – Soft Labour, Strong Gold, Fragile China</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">US CPI : </span> 2.9% YoY in August, up from 2.7%, but still supportive of cuts.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Jobless Claims : </span> Jumped to 263k, the highest since 2023, reinforcing the Fed’s dovish lean.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China : </span> Retail sales and fixed-asset investment were weaker than expected.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Commodities : </span> Silver up, gold at highs above $3,600, dollar eased.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities : </span> Tesla and Micron led gains; Oracle slipped after a sharp rally.
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <p>Markets now await Powell’s SEP remarks at 19:00 UK on Wednesday. The median dot is expected to still show two cuts this year, with more cuts in 2026 than previously projected.</p>
          <div className="relatedImg">
            <img
              src={image3}
              alt="Market view vs Dot Plot 2026"
            />
            <div
              className="zoomBtn"
              onClick={() => handleLargeImg(image3)}
            >
              <button>
                <img
                  src={zoomImg}
                  alt=""
                />
              </button>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">The Week Ahead – Central Bank Cluster and Retail Sales Tes</p>

              <p className="highlightedText">Monday 15th Sep 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>CNY data: Retail Sales, Fixed Asset Investment, Unemployment Rate</p>
                </li>
                <li className="themesPointer">
                  <p>NY Empire Manufacturing Index</p>
                </li>
                <li className="themesPointer">
                  <p>Rightmove HPI UK</p>
                </li>
              </ul>
              <div className="relatedImg">
                <img
                  src={image16}
                  alt="US retail sales grow but slow"
                />
                <div
                  className="zoomBtn"
                  onClick={() => handleLargeImg(image16)}
                >
                  <button>
                    <img
                      src={zoomImg}
                      alt=""
                    />
                  </button>
                </div>
              </div>

              <p className="highlightedText">Tuesday 16th Sep 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>US Retail Sales (+0.3% forecast) and Control Group</p>
                </li>
                <li className="themesPointer">
                  <p>CAD CPI</p>
                </li>
                <li className="themesPointer">
                  <p>German ZEW & EZ Labour Costs</p>
                </li>
                <li className="themesPointer">
                  <p>UK Wages & Employment</p>
                </li>
                <li className="themesPointer">
                  <p>US Industrial Production, Import/Export Prices</p>
                </li>
              </ul>

              <p className="highlightedText">Wednesday 17th Sep 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>JPY Trade Balance</p>
                </li>

                <li className="themesPointer">
                  <p>GBP CPI</p>
                </li>
                <li className="themesPointer">
                  <p>CAD BOC Rate Decision (-25 bp expected)</p>
                </li>
                <li className="themesPointer">
                  <p>FOMC Rate Decision 19:00 UK + SEP/Dot Plot</p>
                </li>
                <li className="themesPointer">
                  <p>Brazil Rate Decision</p>
                </li>
                <li className="themesPointer">
                  <p>Mortgage & Housing Starts US</p>
                </li>
              </ul>

              <p className="highlightedText">Thursday 18th Sep 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>NZD GDP</p>
                </li>

                <li className="themesPointer">
                  <p>AUD Employment</p>
                </li>
                <li className="themesPointer">
                  <p>Norway Rate Decision (-25 bp expected)</p>
                </li>
                <li className="themesPointer">
                  <p>BOE Rate Cut Decision</p>
                </li>
                <li className="themesPointer">
                  <p>US Claims, Philly Fed, Leading Index</p>
                </li>
                <li className="themesPointer">
                  <p>FedEx Earnings</p>
                </li>
              </ul>

              <p className="highlightedText">Friday 19th Sep 2025</p>
              <ul className="pointersSection">
                <li className="themesPointer">
                  <p>BOJ Rate Decision (unchanged expected)</p>
                </li>

                <li className="themesPointer">
                  <p>UK Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>CAD Retail Sales</p>
                </li>
                <li className="themesPointer">
                  <p>GER PPI</p>
                </li>
                <li className="themesPointer">
                  <p>VIX/Index Expiries</p>
                </li>
              </ul>
              <p>
                Big picture: as long as growth holds up, policy is easing, and liquidity is ample, dips are likely to be bought. But the cluster of data plus expiries creates headline risk and
                intraday swings—tight stops and level discipline recommended.
              </p>
            </div>
          </div>
        </div>
        <hr className="divisionLine" />
        <div className="subHeader">
          <div className="contentDivWrapper">
            <div className="contentDiv listOfRecap">
              <p className="highlightedBoldText">Alpha Takeaway: Play the Levels, Not the Hype</p>
              <p>
                Rate cuts are now at the centre of the market’s crosshairs. With multiple central banks moving this week, liquidity is abundant, but direction isn’t guaranteed. The setup favours
                tactical trades over sweeping bets.
              </p>
              <p>
                <span className="highlightedText">Our stance:</span>
              </p>
              <ul className="pointersSection">
                <li className="themesPointer"></li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Equities:</span> Major indices hit fresh highs, but the NAS100’s breakout could still be an “expanding flat” before true higher highs.
                    Semiconductors lead, but watch for consolidation around expiries.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Gold:</span> The metal’s nearly 40% YTD gain puts it at extended levels. Fib targets point to ~$3,720, but the 3,500–3,650 zone may act as a
                    near-term range best to manage entries and avoid chasing.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">China & Global Macro: </span> China’s deflation and slowing investment raise red flags for Q3/Q4 global growth. Stimulus remains the wildcard, but
                    global easing still underpins risk sentiment.
                  </p>
                </li>
                <li className="themesPointer">
                  <p>
                    <span className="highlightedText">Volatility & Positioning: </span> Expiries and central bank decisions dominate this week’s flows. Skew shows hedges leaning downside into FOMC
                    look to fade extremes as positioning resets post-announcements.
                  </p>
                </li>
              </ul>
              <p>This week rewards nimble execution, disciplined levels, and a willingness to pivot fast rather than anchoring to one outcome.</p>

              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image10}
                    alt="Gold LT Fib"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image10)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image5}
                    alt="Market skew in expiry wee"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image5)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
              <div className="imageWrapperCont">
                <div className="relatedImg">
                  <img
                    src={image7}
                    alt="China slowing fast"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image7)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
                <div className="relatedImg">
                  <img
                    src={image14}
                    alt="NAS100 fake breakout or not"
                  />
                  <div
                    className="zoomBtn"
                    onClick={() => handleLargeImg(image14)}
                  >
                    <button>
                      <img
                        src={zoomImg}
                        alt=""
                      />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="button_wrapper">
          <button
            className="gradientButton_small "
            onClick={() => {
              handleRedirect("https://docs.google.com/document/d/1RIpLonU8pCFsOjY2sAAI5Y4FGGWIEElB10NulM0liP8/edit?tab=t.0");
            }}
          >
            Read In-Depth Market Outlook
          </button>
        </div>
      </div>
      {selectedImage && (
        <BlogImagePopper
          image={selectedImage}
          onClose={() => handleLargeImg(null)}
        />
      )}
    </div>
  );
};

export default Blog34;
